import styled from 'styled-components';
import { Flex } from 'rebass/styled-components';
import CommunicatorMessager from './CommunicatorMessager';

const CommunicatorFlex = styled(Flex)`
  width: 100%;
  flex-direction: column;
  flex: 1;
  height: 100%;
  @media screen and (max-width: 52em) {
    height: 332px;
  }
`;

const Wrap = styled(Flex)`
  flex: 1;
  background: white;
  /* max-width: 450px; */
  height: 100%;
  max-height: 100%;
  @media screen and (max-width: 52em) {
    height: 100%;
    max-height: 100%;
  }
`;

const CommunicatorWrapper = ({ conversationId, onSelectConversation }: { conversationId: number, onSelectConversation: (c:string)=>void }) => {
  return (
    <Flex flexDirection="column" style={{ height: '100%', width: '100%' }}>
      <Wrap id="wrp">
        <Flex flexDirection="column" style={{ height: '100%', width: '100%' }}>
          <CommunicatorFlex id="t1">
            <CommunicatorMessager conversationId={conversationId} onSelectConversation={onSelectConversation}/>
          </CommunicatorFlex>
        </Flex>
      </Wrap>
    </Flex>
  );
};

export default CommunicatorWrapper;
